<kt-error class="kt-error"
	[type]="type"
	[image]="image"
	[code]="code"
	[title]="title"
	[subtitle]="subtitle"
	[desc]="desc"
	[errors]="errors"
	[return]="return"></kt-error>
